var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E11F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6654 14.3334C22.6654 19.3334 15.9987 24.3334 15.9987 24.3334C15.9987 24.3334 9.33203 19.3334 9.33203 14.3334C9.33203 12.5653 10.0344 10.8696 11.2847 9.61937C12.5349 8.36913 14.2306 7.66675 15.9987 7.66675C17.7668 7.66675 19.4625 8.36913 20.7127 9.61937C21.963 10.8696 22.6654 12.5653 22.6654 14.3334Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.8334C17.3807 16.8334 18.5 15.7141 18.5 14.3334C18.5 12.9527 17.3807 11.8334 16 11.8334C14.6193 11.8334 13.5 12.9527 13.5 14.3334C13.5 15.7141 14.6193 16.8334 16 16.8334Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceIcon);
export default __webpack_public_path__ + "static/media/placeIcon.bec4bd304c74234e1778342163be5397.svg";
export { ForwardRef as ReactComponent };